import React from 'react';
import { motion } from 'framer-motion';
import { useRegistration } from '../../context/RegistrationContext';
import { Button } from '../../components/common/Button';
import { EVENT_YEAR, EVENT_EDITION, EVENT_PARTICIPANTS, EVENT_LECTURERS } from '../../utils/eventConfig';

const PAINT_GRADIENT = 'linear-gradient(to right, #B8185E, #1B5EA8, #E8B428, #C8392B, #2D7A50)';

const StatBadge = ({ value, label }) => (
  <div className="text-center">
    <div className="text-2xl md:text-3xl font-heading font-bold text-accent">{value}</div>
    <div className="text-xs md:text-sm text-gray-500 uppercase tracking-wide">{label}</div>
  </div>
);

const WelcomePage = () => {
  const { dispatch, actionTypes } = useRegistration();

  const handleStart = () => {
    dispatch({ type: actionTypes.SET_STEP, payload: 2 });
  };

  return (
    <motion.div
      className="container mx-auto px-4 py-8 max-w-4xl"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        {/* Farebný prúžok – náterové farby plagátu */}
        <div style={{ background: PAINT_GRADIENT, height: '5px' }} />

        <div className="p-6 md:p-8">
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-2 text-center">
            Vitajte na Letavách {EVENT_YEAR}!
          </h1>
          <p className="text-center text-accent font-heading font-semibold mb-8 tracking-wide">
            {EVENT_EDITION}. ročník · Kokava-Línia
          </p>

          {/* Štatistiky */}
          <div className="grid grid-cols-3 gap-4 bg-background rounded-lg p-4 mb-8">
            <StatBadge value={EVENT_EDITION} label="ročníkov" />
            <StatBadge value={EVENT_PARTICIPANTS} label="účastníkov" />
            <StatBadge value={EVENT_LECTURERS} label="lektorov" />
          </div>

          <div className="mb-8 text-gray-700 space-y-3">
            <p>
              LETAVY založili študenti Pedagogickej fakulty v Banskej Bystrici, katedry Výtvarnej výchovy.
              Iniciátormi boli Marián „maňo" Lacko z Rimavskej Soboty a Ján Husár z Martina.
              Pokusný ročník tejto akcie sa uskutočnil 2. a 3. septembra 1985 v Rekreačnej oblasti Kurinec.
            </p>
            <p>
              Pôvodný zámer, každoročný plenér bývalých študentov školy sa však za 40 rokov zásadne zmenil.
              Tábor sa zmenil na najväčší počtom účastníkov a na najrozsiahlejší počtom ponúkaných dielní (workshopov) na Slovensku.
            </p>
            <p>
              Za posledných 17 rokov sa LETAVY rozrástli na interdisciplinárnu akciu, kde už neprebiehajú len výtvarné,
              ale aj fotografické, divadelné, literárne, tanečné i hudobné dielne.
              V súčasnosti sme si ako dejisko Letáv zvolili rekreačné stredisko Kokava Línia s nádhernou prírodnou scenériou, v okrese Poltár.
            </p>
          </div>

          <div className="bg-background p-4 rounded-md mb-8 border-l-4 border-accent">
            <h3 className="font-heading font-semibold mb-2 text-primary">Postup registrácie:</h3>
            <ol className="list-decimal pl-5 space-y-1 text-gray-700">
              <li>Vyplnenie osobných údajov</li>
              <li>Výber dielne podľa dostupnosti</li>
              <li>Rezervácia miesta (časovo obmedzená)</li>
              <li>Dokončenie registrácie</li>
            </ol>
          </div>

          <div className="text-center">
            <Button
              variant="accent"
              size="lg"
              onClick={handleStart}
              className="w-full md:w-auto px-10"
            >
              Začať registráciu
            </Button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default WelcomePage;
